<template>
  <v-dialog v-model="dialog" :max-width="500" persistent>
    <v-card>
      <v-toolbar dark :color="titleColor" dense>
        <v-icon left v-if="dirty">mdi-alert</v-icon>
        <v-toolbar-title class="white--text">New Version Available</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pa-4">
        <span>A new version is available. </span>
        <span v-if="dirty"
          >Please <strong>save your changes as soon as possible</strong> and refresh the page to load the new version.
        </span>
        <span v-else>Please refresh the page to load the new version. </span><br />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :color="!dirty ? 'primary' : ''" text @click="refreshNow">Refresh Now</v-btn>
        <v-btn :color="dirty ? 'primary' : ''" text @click="close">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'NewVersionAvailableDialog',
  data() {
    return {
      dialog: false,
      resolve: null,
      dirty: false
    }
  },
  computed: {
    titleColor() {
      return this.dirty ? 'warning' : 'info'
    }
  },
  methods: {
    show(options) {
      this.dirty = options ? !!options.dirty : false
      this.dialog = true

      return new Promise(resolve => {
        this.resolve = resolve
      })
    },
    close() {
      this.dialog = false
      this.resolve(false)
    },
    refreshNow() {
      this.dialog = false
      this.resolve(true)
    }
  }
}
</script>
